<template>
    <div v-if="rule !== null">
        <aside id="side-rule-detail" class="layout-wing-view compliance">

            <div class="compliance-subtitle" :data-type="getDataType">
                <div class="policy-item">
                    <div class="badge">
                        <span v-if="rule.ruleCmplRslt == 'P'" class="icon-tag" :data-type="'success'">
                            {{$t('COMPLIANCE.EVAL_STAT.PASSED')}}
                        </span>

                        <span v-if="rule.ruleCmplRslt == 'F'" class="icon-tag" :data-type="'failer'">
                            {{$t('COMPLIANCE.EVAL_STAT.FAILED') + ' (' + (rule.execYn === 'Y' ? $t('COMPLIANCE.EVAL_STAT.SOLVED'): $t('COMPLIANCE.EVAL_STAT.UNSOLVED')) + ')'}}
                        </span>

                        <span v-if="rule.ruleCmplRslt == 'E'" class="icon-tag" :data-type="'error'">
                            {{$t('COMPLIANCE.EVAL_STAT.ERROR')}}
                        </span>

                        <span v-if="rule.ruleCmplRslt == null" class="icon-tag" data-type="waiting" data-icon="unexamined">
                            {{$t('COMPLIANCE.EVAL_STAT.UNEXAMINED')}}
                        </span>
                        <!-- <span class="icon-tag" data-type="policy-custom">사용자 설정 TODO</span>-->
                    </div>

                    <div class="category-labels">
                        <span v-for="(ctg, index) of rule.ctgLabel" class="icon-tag" data-type="category-label" :key="index">{{ctg}}</span>
                    </div>
                    <div class="position-inherite">
                        <h2 class="name">
                            {{rule.titl}}{{rule.userDefiYn == constants.PARAM.SELECT.N ? rule[$i18n.locale+'RuleTitle'] : rule.ruleTitl}}
                        </h2>
                    </div>
                </div>
                <div class="actions">
                    <template v-if="checkDetail(rule)">
                        <DetailButton
                            :key="rule.ruleId"
                            :rule="rule"
                            :cmpnId="curCmpnId"
                            :user="loginUser"
                            :rsltId="rsltId"
                        />
                    </template>
                    <template v-else>
                        <button type="button" class="buttons" data-type="key"
                            v-if="visibleAction"
                            v-on:click="execAction()"
                        >{{$t('COMPLIANCE.BUTTON.NEXT_ACTION')}}</button>
                    </template>                   
                    <span class="seperate">
                        <button type="button" class="buttons-icon" data-type="ghost" data-size="l" data-icon="close" data-trigger="close" v-on:click="fnCloseRuleDetail(rule)">{{$t('LABEL.CLOSE')}}</button>
                    </span>
                </div>
            </div>

            <!-- 윙 내부 탭 -->
            <nav class="navigation-tab" data-size="s" data-align="left">
                <button v-if="rule.ruleCmplRslt !== 'P' && rule.ruleCmplRslt !== null" type="button" class="tab-item" v-on:click="changeTab('error')" v-bind:class="selTab == 'error' ? 'selected' : null">{{$t('COMPLIANCE.RESULT.SIDE_RULE.TAB.ERROR')}}<!--실패한 내용--></button>
                <button type="button" class="tab-item" v-on:click="changeTab('basic')" v-bind:class="selTab == 'basic' ? 'selected' : null">{{$t('COMPLIANCE.RESULT.SIDE_RULE.TAB.BASIC')}}<!--기본정보--></button>
            </nav>


            <div v-if="selTab === 'error'" class="wing-contents">
                <h3 class="compliance-account">{{ $t('COMPLIANCE.LABEL.RELATED_ACCOUNT')}}<!--연관 계정--></h3>
                <div-loading v-if="pending" :full="false"></div-loading>
                <div>
                    <dl class="list-compliance-failer">
                        <template v-for="(acc, index) in rule.accAlias">
                            <complianceSideRuleDetailTable v-if="isContainVal(acc)"
                                :key="index"
                                :rule="rule"
                                :acc="acc"
                                :ruleDetails="ruleDetails"
                                :commonInfo="commonInfo"
                                :failedRulesList="failedRulesList"
                            />
                        </template>
                    </dl>
                </div>
            </div>

            <div v-if="selTab === 'basic'" class="wing-contents">
                <side-rule-detail-info
                    v-bind:rule="rule"
                    v-bind:action-template-list="actionTemplateList"
                    v-bind:user-list="userList"
                    :roleCode="roleCode"
                    parents-type="cmpl">
                </side-rule-detail-info>
            </div>
        </aside>
    </div>
</template>

<script>

    import SideRuleDetailInfo from '../rule/SideRuleDetailInfo.vue'
    import complianceSideRuleDetailTable from './complianceSideRuleDetailTable.vue'
    import {mapGetters} from "vuex";
    import DetailButton from './widget/DetailButton.vue'
    export default {
        name: 'detail',
        props: ['policy', 'rule', 'categoryList', 'actionTemplateList', 'userList', 'ruleDetails', 'commonInfo', 'failedRulesList', 'rsltId', 'roleCode'],
        components: {
            'side-rule-detail-info' : SideRuleDetailInfo,
            complianceSideRuleDetailTable,
            DetailButton
        },
        data: function () {
            return {
                selTab: null,
            }
        },
        created: function () {
            this.selTab = 'error'
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId',
                loginUser: 'user/loginUser'
            }),
            getDataType: function() {
                //console.log("rule :", this.rule)
                return this.rule.ruleCmplRslt == null ? 'unexamined' : this.rule.ruleCmplRslt === 'R' ? 'examining' : this.rule.ruleCmplRslt == 'P' ? 'success' : 'failer'
            },
            getMenuAuth: function(){
                //메뉴 별 권한
                let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.COMPLIANCE_ASSESSMENT})
                return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
            },
            pending() {
                const value = _.valuesIn(this.ruleDetails);
                return (value.length === 0)
            },
            visibleAction: function(){
                let actnFilter = this.rule.actnVal.filter((actn) => { return actn.actnId !== null && actn.actnId != this.constants.PARAM.SELECT.NONE})
                return  actnFilter.length > 0 && (this.rule !== null && this.rule.execYn === 'N' && this.rule.ruleCmplRslt === 'F') && this.getMenuAuth == this.constants.AUTH_TYPE.EDIT
            }
        },
        watch:{
            rule: function() {
                this.selTab = this.rule != null &&
                    (this.rule.ruleCmplRslt === this.constants.COMPLIANCE_STAT.PASS ||
                    _.isNil(this.rule.ruleCmplRslt))
                        ? 'basic' : 'error';

            }
        },
        methods: {
            changeTab(tab){
                this.selTab = tab;
            },
            // X 버튼
            fnCloseRuleDetail: function() {
                this.$emit('hideDetail');
            },
            // TODO : 한개의 Failed Rule의 Action 실행
            execAction() {
                this.$emit('executeAction', this.rule);
            },
            getCategoryLabel(ctgId) {
                var categoryLabel = '';
                if(this.categoryList != null) {
                    for (var category of this.categoryList) {
                        if (category.ctgId === ctgId) {
                            categoryLabel = category.ctgLabel;
                        }
                    }
                }
                return categoryLabel;
            },
            isContainVal: function(acc) {
                var isContained = true;
                var accIds = acc.split("(")[0];
                const eventLog = _.get(this.ruleDetails, "evntLog", false);
                if (eventLog) {
                    if (this.Common.isJSON(eventLog)) {
                        var evntList = JSON.parse(eventLog);
                        for(let evnt of evntList){
                           if (evnt.accId === accIds) {
                                return isContained;
                           }
                        }
                    } else {
                        var evntLogList = eventLog.split(' | ');
                        for(var evnt of evntLogList){
                            var logList = evnt.split('%$%')
                            if (logList.length > 0) {
                                var accId = logList[0].trim();
                                if (accIds === accId) {
                                   return isContained;
                                }
                            }
                        }
                    }
                }
                return !isContained;
            },
            checkDetail: function(rule) {
                let isIntergartion = false;
                let isFailSoveld = false;
                // check actionId is intergartion?
                (rule.actnVal || []).forEach(item => {
                    if (item.actnId == 'actn_alertnow') {
                        isIntergartion = true;
                        return true;
                    }
                });

                // check status is fail soveld?
                isFailSoveld = rule.ruleCmplRslt === 'F' && rule.autoExeYn === 'Y' && rule.execYn !== 'N';

                return isIntergartion && isFailSoveld;
            }
        },
        destroyed: function() {
            $('body').removeAttr('data-wing-expand');
        }
    }
</script>


<style scoped>
body[data-wing-expand] .layout-wing-view {
    box-shadow: -5px 16px 8px #888888;
}
.position-inherite .name {
    position: inherit !important;
}
.policy-item {
    width: calc(100% - 200px);
}
.next-action {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/compliance/complianceSideRuleDetail.vue